import Transition from './Transition';

export type { TransitionProps } from './Transition';

export default Transition;
